import { create } from 'zustand';

interface MagicLinkState {
  linkSent: boolean;
  email: string;
  setLinkSent: () => void;
  setEmail: (email: string) => void;
  reset: () => void;
}

export const useMagicLinkStore = create<MagicLinkState>((set) => ({
  linkSent: false,
  email: '',
  setLinkSent: (): void => set({ linkSent: true }),
  setEmail: (email): void => set({ email }),
  reset: (): void => set({ linkSent: false, email: '' }),
}));
